import { createContext } from 'preact'

const ComponentContext = createContext<Record<string, any> | null>(null)

export default ComponentContext
